import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RadioGroup } from "@radix-ui/themes";
import { getTotal } from "../cart/cart";
import {PAYMENT, SHIPPING} from "../api/config";

const fmt = (n)=> new Intl.NumberFormat("sk-SK",{style:"currency",currency:"EUR"}).format(n||0);

export default function CheckoutPage(){
    const navigate = useNavigate();
    const [ship, setShip] = useState("kurier");
    const [pay,  setPay]  = useState("kartou");

    const subtotal = getTotal();
    const shipping = SHIPPING[ship].price;
    const payment  = PAYMENT[pay].price;
    const total    = subtotal + shipping + payment;

    function handleNext(){
        // uložíme voľby pre ďalší krok (údaje zákazníka)
        localStorage.setItem("checkout_v1", JSON.stringify({ ship, pay }));
        navigate("/udaje"); // zatiaľ na tvoju stránku s kontaktom
    }

    return (
        <div className="container py-4">
            <h1 className="h4 mb-4">Doprava a platba</h1>
            <div className="row g-4">
                {/* ľavý stĺpec – voľby */}
                <div className="col-lg-8">
                    <div className="card mb-4">
                        <div className="card-body">
                            <h2 className="h5 mb-3">Doprava</h2>
                            <RadioGroup.Root value={ship} onValueChange={setShip} className="d-block">
                                {Object.entries(SHIPPING).map(([key, v]) => (
                                    <label key={key} className="d-flex align-items-center gap-3 mb-2">
                                        <RadioGroup.Item value={key} />
                                        <span>{v.label}</span>
                                        <span className="ms-auto text-muted">{fmt(v.price)}</span>
                                    </label>
                                ))}
                            </RadioGroup.Root>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <h2 className="h5 mb-3">Platba</h2>
                            <RadioGroup.Root value={pay} onValueChange={setPay} className="d-block">
                                {Object.entries(PAYMENT).map(([key, v]) => (
                                    <label key={key} className="d-flex align-items-center gap-3 mb-2">
                                        <RadioGroup.Item value={key} />
                                        <span>{v.label}</span>
                                        <span className="ms-auto text-muted">
                      {v.price ? `+ ${fmt(v.price)}` : fmt(0)}
                    </span>
                                    </label>
                                ))}
                            </RadioGroup.Root>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between mt-3">
                        <Link to="/kosik" className="btn btn-outline-secondary rounded-pill">← Späť do košíka</Link>
                        <button className="btn btn-brown" onClick={handleNext}>Pokračovať</button>
                    </div>
                </div>

                {/* pravý stĺpec – súhrn */}
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <span>Medzisúčet</span><span className="fw-semibold">{fmt(subtotal)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Doprava</span><span>{fmt(shipping)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Platba</span><span>{fmt(payment)}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Spolu</span>
                                <span className="fw-bold fs-5">{fmt(total)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
